module.exports = __webpack_public_path__ + "img/logo.08fc01ec.png";